import {Component, Input, OnInit} from '@angular/core';
import {ClipboardService} from "ngx-clipboard";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrls: ['./copy-button.component.scss']
})
export class CopyButtonComponent implements OnInit {

  $copying: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @Input() content: string;
  @Input() label: string;

  constructor(public clipboard: ClipboardService) { }

  ngOnInit(): void {
  }

  copy(){

    this.$copying.next(true);
    this.clipboard.copy(this.content);

    setTimeout(()=>{
      this.$copying.next(false);
    }, 5000);

  }


}
